import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Fetches the form-fields configuration for a screen and returns helpers.
 *
 * Usage:
 *   const { visible, label, loaded } = useFieldsConfig("qualificacao_inicial");
 *   {visible("contact.name") && <Field label={label("contact.name","Nome")}>...</Field>}
 *
 * If a field key isn't in the config (e.g. brand-new hard-coded field not yet seeded),
 * we default to visible=true so nothing disappears silently.
 */
export default function useFieldsConfig(screen) {
  const [fields, setFields] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get(`/form-fields?screen=${screen}`)
      .then((r) => { if (!cancelled) setFields(r.data || []); })
      .finally(() => { if (!cancelled) setLoaded(true); });
    return () => { cancelled = true; };
  }, [screen]);

  const map = {};
  fields.forEach((f) => { map[f.key] = f; });

  return {
    loaded,
    fields,
    visible: (key) => {
      const f = map[key];
      if (!f) return true;
      return f.active !== false;
    },
    label: (key, def) => {
      const f = map[key];
      return f?.label || def;
    },
    required: (key, def = false) => {
      const f = map[key];
      return f?.required ?? def;
    },
    field: (key) => map[key],
  };
}
